import { render, staticRenderFns } from "./RecursiveDocuments.vue?vue&type=template&id=5e130c20"
import script from "./RecursiveDocuments.vue?vue&type=script&lang=js"
export * from "./RecursiveDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports